import { updatePaymentSystemLimit } from '../api/updatePaymentSystemLimit';

const setUpdatePaymentSystemLimit = (params, callbackSuccess ) => {
    return async (dispatch, getState) => {
        try {
            await updatePaymentSystemLimit(params);
            alert('Сохранено')
            if (callbackSuccess) {
                callbackSuccess()
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setUpdatePaymentSystemLimit
}